// ======================================================================
// File Name       : ContentQuestionEditSingleHeader
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, FormControl, Form } from 'react-bootstrap';
import SelectBox from '../../components/SelectBox';
import FileUpload from '../../components/FileUpload';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import FormControlValidate from '../FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { getItemBoxName } from '../../utils/index';

class ContentQuestionEditSingleHeader extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.onInputChange(name, value);
    } else {
      this.props.onInputChange(event, data);
    }
  };
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const {
      questionKind,
      questionSecernId,
      questionTitle,
      questionUseForm,
      questionContent,
      answerFormula,
      onInputChange,
      onFileChange,
      questionZipFileName,
      selectAnswerFormula,
    } = this.props;
    this.refsToValidate = [];
    const titleQuestionKind = getItemBoxName(SELECT_BOX_DATA.QUESTION_TYPE, questionKind);
    let contentUseForm = null;
    if (questionUseForm == 0) {
      contentUseForm = (
        <FormControlValidate
          as="textarea"
          className="textArea"
          name="questionContent"
          onChange={this.onChange}
          value={questionContent}
          maxLength="30000"
          rows={7}
          required
          label="問題内容"
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
      );
    } else {
      contentUseForm = (
        <div>
          <Col sm={12} className="padding-left-clear">
            <FileUpload
              labelName="ファイル選択"
              inputId={'questionZipFileName'}
              onChange={onFileChange}
              accept={'application/zip,application/x-zip,application/x-zip-compressed'}
              fileName={questionZipFileName}
            />
          </Col>
          <Col sm={12} className="margin-top-10 padding-left-clear">
            <FormControlValidate
              label="問題内容"
              validateType={VALIDATE_TYPE.LABEL}
              value={questionZipFileName && `ファイル名：${questionZipFileName}`}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              required
            />
          </Col>
        </div>
      );
    }
    return (
      <div>
        <Col sm={12} className="padding-left-clear">編集する項目を指定してください</Col>
        <Col sm={12} as={Form.Label} className="margin-top-10">
          基本設定
        </Col>
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>問題形式</Col>
            <Col sm={7} className="margin-top-10">
              {titleQuestionKind}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              問題識別ID
            </Col>
            <Col sm={7} className="margin-top-10">
              {questionSecernId}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              問題タイトル<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7}>
              <FormControlValidate
                label="問題タイトル"
                type="text"
                name="questionTitle"
                value={questionTitle}
                onChange={this.onChange}
                maxLength="256"
                required
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} as={Form.Label}>
              問題内容<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={7} className="padding-left-right-clear">
              <Col sm={6}>
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="questionUseForm"
                  id="questionUseForm-0"
                  value={0}
                  checked={questionUseForm == 0}
                  onChange={this.onChange}
                  label='HTMLを使用しない'></Form.Check>
              </Col>
              <Col sm={6} className="form-label">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="questionUseForm"
                  id="questionUseForm-1"
                  value={1}
                  checked={questionUseForm == 1}
                  onChange={this.onChange}
                  label='HTMLを使用する'></Form.Check>
              </Col>
              <Col sm={12} className="margin-top-10">
                {contentUseForm}
              </Col>
            </Col>
          </Form.Group>
        </Col>
      </div>
    );
  }
}

export default ContentQuestionEditSingleHeader;
